import { Component, OnInit } from '@angular/core';
import 'rxjs/add/operator/filter';
import { Router } from '@angular/router';
import * as $ from "jquery";
import { jwtDecode } from 'jwt-decode';

@Component({
  selector: 'app-login-layout',
    templateUrl: './login-layout.component.html',
    styleUrls: ['./login-layout.component.css']
})
export class LoginLayoutComponent implements OnInit {

    constructor(private router: Router,) { }

  ngOnInit() {
      this.checkToken();
  }
  
  checkToken(): void {
    // Retrieve the token from localStorage
    const token = localStorage.getItem('myToken');
    
    // Check if token exists
    if (token) {
      try {
        // Decode the token to check expiry (assuming JWT)
        const decodedToken: any = jwtDecode(token);
        const currentTime = Math.floor(Date.now() / 1000);

        // Check if token is expired
        if (decodedToken.exp > currentTime) {
          // If token is valid, redirect to /home
          this.router.navigate(['/home']);
        } else {
          // If token is expired, clear all items from localStorage
          localStorage.clear();
        }
      } catch (error) {
        // If token decoding fails, clear all items from localStorage
        console.error('Invalid token', error);
        localStorage.clear();
      }
    }
  }

}
